import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spin } from "antd";
import axios from "axios";
import { API_URL } from "../../config";

const EcgTab = (props) => {
  const { patient_id } = props;
  const [ecgDatas, setEcgDatas] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/document/${patient_id}/`
        );
        const documents = response.data;

        const ecgDocuments = documents.filter(
          (document) =>
            document.category === "ECG_REPORTS" &&
            !document.content_type.includes("pdf")
        );

        setEcgDatas(ecgDocuments.reverse());
        if (ecgDocuments.length > 0) {
          const firstImage = `${API_URL}/document/?document_id=${ecgDocuments[0].document_id}`;
          setCurrentImage(firstImage); 
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [patient_id]);

  const loadImage = (index) => {
    if (index >= 0 && index < ecgDatas.length) {
      const document = ecgDatas[index];
      const imageUrl = `${API_URL}/document/?document_id=${document.document_id}`;
      setCurrentImage(imageUrl);
      setCurrentIndex(index);
    }
  };

  const goToFirst = () => loadImage(0);  
  const goToPrev = () => loadImage(currentIndex - 1); 
  const goToNext = () => loadImage(currentIndex + 1);   
  const goToLast = () => loadImage(ecgDatas.length - 1); 

  return (
    <Col xs={24} md={24}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <Spin size="large" />
        </div>
      ) : ecgDatas.length > 0 ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "550px",
              margin: "auto",
            }}
          >
            {currentImage ? (
              <img
                alt="ECG Report"
                src={currentImage}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
                onError={(e) => (e.target.style.display = "none")}
              />
            ) : (
              <Spin size="large" />
            )}
          </div>
          <Row
            justify="space-between"
            align="middle"
            style={{ width: "100%", marginTop: "1%" }}
          >
            <Col>
              <Row gutter={16}>
                <Col>
                  <Button
                    type="primary"
                    onClick={goToFirst}
                    disabled={currentIndex === 0}
                  >
                    First
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={goToPrev}
                    disabled={currentIndex === 0}
                  >
                    Prev
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col>
              <div style={{ textAlign: "center" }}>
                {`Round ${currentIndex + 1} of ${ecgDatas.length}`}
              </div>
            </Col>
            <Col>
              <Row gutter={16} justify="end">
                <Col>
                  <Button
                    type="primary"
                    onClick={goToNext}
                    disabled={currentIndex === ecgDatas.length - 1}
                  >
                    Next
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={goToLast}
                    disabled={currentIndex === ecgDatas.length - 1}
                  >
                    Last
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <div>No ECG Data Available</div>
      )}
    </Col>
  );
};

export default EcgTab;
